/**
 * Convert relative image URLs to absolute
 * Images are served from /uploads (not /api/uploads)
 */
export function getImageUrl(url: string | null | undefined): string | null {
  if (!url) return null;
  const normalizedUrl = url.replace(/ /g, '%20');
  const cdnBase = (import.meta.env.VITE_CDN_URL || '').replace(/\/$/, '');
  
  // If already absolute URL, return as-is
  if (normalizedUrl.startsWith('http://') || normalizedUrl.startsWith('https://')) {
    return normalizedUrl;
  }
  
  // If relative path to uploads, prepend BASE URL (without /api)
  if (normalizedUrl.startsWith('/uploads')) {
    if (cdnBase) {
      return `${cdnBase}${normalizedUrl}`;
    }

    const apiBase = import.meta.env.VITE_API_URL || 'http://localhost:3000/api';
    try {
      const parsed = new URL(apiBase);
      return `${parsed.origin}${normalizedUrl}`;
    } catch {
      const fallbackBase = apiBase.replace(/\/api\/?$/, '') || 'http://localhost:3000';
      return `${fallbackBase}${normalizedUrl}`;
    }
  }
  
  // Return as-is if other format
  return normalizedUrl;
}
